import React, { useState, useEffect } from 'react';
import { Button, Alert } from 'react-bootstrap';

const PWAUpdatePrompt = () => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    let registration;

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        registration = reg;
        
        // Проверяем наличие ожидающего service worker
        if (reg.waiting) {
          setWaitingWorker(reg.waiting);
          setShowUpdatePrompt(true);
        }

        // Слушаем обновления
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Новый service worker установлен и готов
              setWaitingWorker(newWorker);
              setShowUpdatePrompt(true);
            }
          });
        });
      });

      // Слушаем сообщения от service worker (только в production — в dev вызывает бесконечную перезагрузку)
      if (process.env.NODE_ENV === 'production') {
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });
      }
    }
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      // Отправляем сообщение service worker для активации
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdatePrompt(false);
      // Перезагрузка произойдет автоматически через событие controllerchange
    }
  };

  const handleDismiss = () => {
    setShowUpdatePrompt(false);
  };

  if (!showUpdatePrompt) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        maxWidth: '90%',
        width: '400px'
      }}
    >
      <Alert variant="info" className="mb-0 shadow-lg">
        <Alert.Heading>Доступно обновление</Alert.Heading>
        <p className="mb-3">
          Новая версия приложения готова к установке. Хотите обновить сейчас?
        </p>
        <div className="d-flex gap-2">
          <Button variant="primary" size="sm" onClick={handleUpdate}>
            Обновить
          </Button>
          <Button variant="outline-secondary" size="sm" onClick={handleDismiss}>
            Позже
          </Button>
        </div>
      </Alert>
    </div>
  );
};

export default PWAUpdatePrompt;

